module.exports = {
	"account": {
		"Create": [
			"account:CreateAccount",
			"silo:CreateSilo"
		],
		"Read": [
			"account:ListAccounts",
			"account:ReadAccount",
			"account:ReadSettings",
			"entity:ReadEntity"
		],
		"Update": [
			"account:UpdateAccount",
			"account:UpdateSettings",
			"entity:UpdateEntity"
		]
	},
	"affiliation": {
		"Create": [
			"account:CreateAffiliation"
		],
		"Read": [
			"affiliation:ListAffiliations"
		],
		"Update": [
			"affiliation:UpdateAffiliation"
		],
		"Delete": []
	},
	"entity": {
		"Read": [
			"entity:ReadEntity"
		],
		"Update": [
			"entity:UpdateEntity"
		]
	},
	"communication": {
		"Read": [
			"communication:ReadCommunication"
		]
	},
	"image": {
		"Create": [
			"image:CreateEmailImage",
			"image:CreateFacebookImage",
			"image:CreateMailImage"
		],
		"Read": [
			"image:ListImageContainers",
			"image:ReadImageContainer",
			"image:ReadEmailImage",
			"image:ReadFacebookImage",
			"image:ReadMailImage"
		],
		"Update": [
			"image:UpdateEmailImage",
			"image:UpdateFacebookImage",
			"image:UpdateImageContainer",
			"image:UpdateMailImage"
		],
		"Delete": []
	},
	"offer": {
		"Create": [
			"account:CreateOffer",
			"silo:CreateOffer"
		],
		"Read": [
			"offer:ListOffers",
			"offer:ReadOffer"
		],
		"Update": [
			"offer:UpdateOffer"
		],
		"Delete": [
			"offer:DeleteOffer"
		]
	},
	"import": {
		"Create": [],
		"Read": [],
		"Update": [],
		"Delete": []
	},
	"report": {
		"Create": [],
		"Read": [],
		"Update": [],
		"Delete": []
	},
	"silo": {
		"Create": [
			"silo:CreateSilo"
		],
		"Read": [
			"silo:ListSilos",
			"silo:ReadSettings",
			"silo:ReadSilo",
			"silo:ReadTags"
		],
		"Update": [
			"silo:UpdateSettings",
			"silo:UpdateSilo"
		]
	},
	"standardModel": {
		"Create": [
			"standardModel:CreateStandardModel"
		],
		"Read": [
			"standardModel:ListStandardModel",
			"standardModel:ReadStandardModel"
		],
		"Update": [
			"standardModel:UpdateStandardModel"
		],
		"Delete": [
			"standardModel:DeleteStandardModel"
		]
	},
	"tag": {
		"Create": [
			"account:CreateTag"
		],
		"Read": [
			"tag:ReadTag"
		],
		"Update": [
			"tag:UpdateTag"
		],
		"Delete": [
			"tag:DeleteTag"
		]
	},
	"template": {
		"Create": [
			"account:CreateEmailTemplate",
			"account:CreateFacebookTemplate",
			"account:CreateMailTemplate",
			"silo:CreateEmailTemplate",
			"silo:CreateFacebookTemplate",
			"silo:CreateMailTemplate"
		],
		"Read": [
			"template:ListTemplates",
			"template:ReadTemplate",
			"template:ReadEmailTemplate",
			"template:ReadFacebookTemplate",
			"template:ReadMailTemplate"
		],
		"Update": [
			"template:UpdateEmailTemplate",
			"template:UpdateFacebookTemplate",
			"template:UpdateMailTemplate",
			"template:UpdateTemplate"
		],
		"Delete": []
	},
	"typedValue": {
		"Create": [
			"typedValue:CreateTypedValue"
		],
		"Read": [
			"typedValue:ListTypedValues"
		],
		"Update": [
			"typedValue:UpdateTypedValue"
		],
		"Delete": [
			"typedValue:DeleteTypedValue"
		]
	},
	"vinDecoding": {
		"Create": [
			"vinDecoding:CreateVinDecoding"
		],
		"Read": [
			"vinDecoding:ListVinDecoding",
			"vinDecoding:ReadVinDecoding"
		],
		"Update": [
			"vinDecoding:UpdateVinDecoding"
		],
		"Delete": [
			"vinDecoding:DeleteVinDecoding"
		]
	},
	"audience": {
		"Create": [
			"audience:CreateAudience"
		],
		"Read": [
			"audience:ReadAudience",
			"audience:RequestAudience"
		],
		"Update": [
			"audience:UpdateLISTAudience",
			"audience:UpdateTMNAAudience",
			"audience:UpdateDMSAudience",
			"audience:UpdateCCDBAudience",
			"audience:UpdateAudience"
		],
		"Delete": [
			"audience:DeleteLISTAudience",
			"audience:DeleteTMNAAudience",
			"audience:DeleteDMSAudience",
			"audience:DeleteCCDBAudience",
			"audience:DeleteAudience"
		],
		"ManageList": [
			"audience:DeleteAudience",
			"audience:DeleteLISTAudience",
			"audience:UpdateAudience",
			"audience:UpdateLISTAudience"
		]
	},
	"message": {
		"Create": [
			"message:CreateMessage"
		],
		"Read": [
			"message:ReadMessage"
		],
		"Update": [
			"message:UpdateMessage"
		],
		"Delete": [
			"message:DeleteMessage"
		]
	},
	"user": {
		"Create": [],
		"Read": [],
		"Update": [],
		"Delete": []
	},
	"datasource": {
		"Create": [],
		"Read": [
			"datasource:ReadDataSource"
		],
		"Update": [
			"datasource:UpdateDataSource"
		],
		"Delete": []
	},
	"ui": {
		"ViewTemplate": [
			"ui:ViewTemplate"
		],
		"ManageTemplate": [
			"ui:EditTemplate",
			"ui:CreateTemplate"
		],
		"ShareTemplate": [
			"ui:ShareTemplate"
		],
		"ViewOffer": [
			"ui:ViewOffer"
		],
		"ManageOffer": [
			"ui:EditOffer",
			"ui:CreateOffer",
			"ui:DeleteOffer"
		],
		"ShareOffer": [
			"ui:ShareOffer"
		],
		"ViewImage": [
			"ui:ViewImage"
		],
		"ManageImage": [
			"ui:EditImage",
			"ui:CreateImage"
		],
		"ShareImage": [
			"ui:ShareImage"
		],
		"ViewMessage": [
			"ui:ViewMessage"
		],
		"ManageMessage": [
			"ui:EditMessage",
			"ui:CreateMessage"
		],
		"ShareMessage": [
			"ui:ShareMessage"
		],
		"ApproveMessage": [
			"ui:ApproveMessage"
		],
		"ViewOCPeReport": [
			"ui:ViewOCPeReport"
		],
		"ViewOnDemandReport": [
			"ui:ViewOnDemandReport"
		],
		"ViewAccount": [
			"ui:ViewAccount"
		],
		"ManageAccount": [
			"ui:EditAccount"
		],
		"ViewSilo": [
			"ui:ViewSilo"
		],
		"ManageSilo": [
			"ui:EditSilo"
		],
		"ViewTag": [
			"ui:ViewTag"
		],
		"ManageTag": [
			"ui:CreateTag",
			"ui:EditTag",
			"ui:DeleteTag"
		],
		"ApplyTag": [
			"ui:ApplyTag",
			"ui:UnapplyTag"
		],
		"ViewSystem": [
			"ui:ViewSystem"
		],
		"ManageSystem": [
			"ui:EditSystem"
		],
		"ViewSwitcherActiveStatus": [
			"ui:ViewSwitcherActiveStatus"
		],
		"ViewSwitcherSuspendedStatus": [
			"ui:ViewSwitcherSuspendedStatus"
		],
		"ViewProofs": [
			"ui:ViewProofs"
		],
		"ViewImportExportOffers": [
			"ui:ViewImportExportOffers"
		],
		"ViewReportSettings": [
			"ui:ViewReportSettings"
		],
		"ManageReportSettings": [
			"ui:EditReportSettings"
		],
		"ViewDigitalReport": [
			"ui:ViewDigitalReport"
		],
		"ViewVinDecoding": [
			"ui:ViewVinDecoding"
		],
		"ManageVinDecoding": [
			"ui:ManageVinDecoding"
		],
		"ViewStandardModel": [
			"ui:ViewStandardModel"
		],
		"ManageStandardModel": [
			"ui:ManageStandardModel"
		],
		"ViewMonitoring": [
			"ui:ViewMonitoring"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/feature-policy/activity-mapping.json
// module id = 113
// module chunks = 51